module.exports = __webpack_public_path__ + "img/bg_01.7e17e0f4.png";